import { render, staticRenderFns } from "./WeekDayDurations.vue?vue&type=template&id=4518a2e4&scoped=true"
import script from "./WeekDayDurations.vue?vue&type=script&lang=js"
export * from "./WeekDayDurations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4518a2e4",
  null
  
)

export default component.exports